import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["iconLeading", "iconTrailing", "children", "theme"];
import React from 'react';
import { deprecatedPropWarning } from "../../deprecationWarnings";
import { IconLeading } from "./IconLeading";
import { IconTrailing } from "./IconTrailing";
import { InputContainer } from "./InputContainer";
export var FormInputIcon = function FormInputIcon(_ref) {
  var iconLeading = _ref.iconLeading,
      iconTrailing = _ref.iconTrailing,
      children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  if (theme) {
    deprecatedPropWarning('theme', 'This component is intended to inherit its parent’s color set or color.');
  }

  return /*#__PURE__*/React.createElement(InputContainer, Object.assign({
    iconLeading: iconLeading,
    iconTrailing: iconTrailing
  }, props), iconLeading && /*#__PURE__*/React.createElement(IconLeading, {
    "aria-hidden": "true",
    iconLeading: iconLeading
  }), children, iconTrailing && /*#__PURE__*/React.createElement(IconTrailing, {
    "aria-hidden": "true",
    iconTrailing: iconTrailing
  }));
};
/**
* **FormInputIcon** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormInputIcon) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-form-forminputicon--default) | [Encore](https://encore.spotify.net/web/components/form?format=figma-figma#forminputicon) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=0:858) |
*
* The FormInputIcon wraps a FormInput and properly position a leading or trailing icon within it.
*
* @example
* () => (
*  <FormInputIcon iconLeading={<IconSearch />}>
*    <FormInput type="text" placeholder="Search" />
*  </FormInputIcon>
*);
*
*/

export default FormInputIcon;